import { useQuery } from "@tanstack/react-query";
import { deltamathAPI } from "../../manager/utils";
import axios from "axios";

const NonSuperAdminCredentials = () => {
  const { data } = useQuery({
    queryKey: ["nonSuperAdminCredentials"],
    queryFn: async () => {
      const response = await axios.post(
        deltamathAPI() + "/admin_new/data/superAdminName"
      );
      return response.data;
    },
  });

  return (
    <div className="max-w-md">
      <p>
        Your account does not have access to the LTI integration credentials.
        The Key and Secret for this integration are located within the Admin
        Portal of the following account(s):{" "}
        <div>
          {data?.superAdmins
            .map(
              (superAdmin: { first: string; last: string; email: string }) =>
                `${superAdmin.first} ${superAdmin.last}`
            )
            .join(", ")}
        </div>
      </p>
    </div>
  );
};

export default NonSuperAdminCredentials;
